import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  &:before {\n    content: '“';\n  }\n\n  &:after {\n    content: '”';\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { useTheme } from "styled-components";
import { Box, Heading, Image, Text, Link } from "@miro-site/core";
var Container = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        $py: theme.header.customerSpotlight.verticalPadding,
        $px: theme.header.customerSpotlight.horizontalPadding,
        $styles: {
            borderRadius: theme.header.highlighted.radius,
            backgroundColor: theme.header.highlighted.background
        }
    };
}).withConfig({
    componentId: "sc-2e2867aa-0"
})(_templateObject());
var Blockquote = styled(Text).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "blockquote",
        $variant: theme.header.customerSpotlight.quote.variant,
        $styles: {
            color: theme.header.colors.secondaryText
        }
    };
}).withConfig({
    componentId: "sc-2e2867aa-1"
})(_templateObject1());
var Headline = styled(Heading).attrs(function(param) {
    var theme = param.theme;
    return {
        as: theme.header.customerSpotlight.headline.as,
        $mb: theme.header.customerSpotlight.margins.afterHeadline,
        $variant: theme.header.customerSpotlight.headline.variant
    };
}).withConfig({
    componentId: "sc-2e2867aa-2"
})(_templateObject2());
var ViewAllLink = styled(Link).attrs(function(param) {
    var theme = param.theme;
    return {
        $variant: theme.header.customerSpotlight.viewAllLink.variant,
        $color: theme.header.customerSpotlight.viewAllLink.color,
        $size: theme.header.customerSpotlight.viewAllLink.size,
        withArrow: theme.header.customerSpotlight.viewAllLink.withArrow
    };
}).withConfig({
    componentId: "sc-2e2867aa-3"
})(_templateObject3());
var CustomerSpotlight = function(props) {
    var title = props.title, description = props.description, image = props.image, logo = props.logo, showAllLink = props.showAllLink;
    var ref = useTheme(), customerSpotlight = ref.header.customerSpotlight;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Headline, {
                children: title
            }),
            image && /*#__PURE__*/ _jsx(Box, {
                $mb: customerSpotlight.margins.afterImage,
                $styles: {
                    maxWidth: customerSpotlight.imageWidth
                },
                children: /*#__PURE__*/ _jsx(Image, _object_spread({}, image))
            }),
            logo && /*#__PURE__*/ _jsx(Box, {
                $mb: customerSpotlight.margins.afterLogo,
                $styles: {
                    maxWidth: customerSpotlight.logoWidth
                },
                children: /*#__PURE__*/ _jsx(Image, _object_spread({}, logo))
            }),
            /*#__PURE__*/ _jsx(Blockquote, {
                $mb: customerSpotlight.margins.afterQuote,
                children: description
            }),
            showAllLink && /*#__PURE__*/ _jsx(ViewAllLink, {
                href: showAllLink.path,
                children: showAllLink.title
            })
        ]
    });
};
export default CustomerSpotlight;
